import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import QuoteCreate from './Create';
import QuoteDetail from './Detail';
import QuoteList from './List';
import Common from '../../../../shared/common';
import { allMessages } from "../../../../../_metronic/i18n/I18nProvider";
import { paymentPeriods } from '../../../../shared/lookup';

export const itqQuotableStatuses = ['AQ', 'APMRQ', 'ARQ'];

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    Comments: { visible: false, label: '', required: false },
    ItemsList: { visible: false, label: '', required: false },
    TotalListPrice: { visible: false, label: '', required: false },
    InstructionToQuoteDescription: { visible: false, label: '', required: false },
    TotalAssessed: { visible: false, label: '', required: false },
    TotalPrice: { visible: false, label: '', required: false },
    StartDate: { visible: false, label: '', required: false },
    CompletionDate: { visible: false, label: '', required: false },
    DelayAmount: { visible: false, label: '', required: false },
    DelayPaymentPeriod: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyAmount: { visible: false, label: '', required: false },
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getQuoteFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract, componentProps) => {
    const fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.Description = { visible: true, label: resources.DescriptionLabel, required: true };
    fields.Comments = { visible: true, label: resources.Comments, required: true };
    fields.ItemsList = { visible: true, label: resources.ItemsListLabel, required: true };
    fields.TotalListPrice = { visible: true, label: resources.TotalListPriceLabel, required: true };
    fields.InstructionToQuoteDescription = { visible: true, label: resources.InstructionToQuoteDescription, required: true };

    fields.TotalAssessed = { visible: true, label: resources.TotalAssessedLabel, required: true };
    fields.TotalPrice = { visible: true, label: resources.TotalPriceLabel, required: true };
    fields.StartDate = { visible: true, label: resources.StartDateLabel, required: true };
    fields.CompletionDate = { visible: true, label: resources.CompletionDateLabel, required: true };
    fields.DelayAmount = { visible: true, label: resources.DelayAmountLabel, required: true };
    fields.DelayPaymentPeriod = { visible: true, label: resources.DelayPaymentPeriodLabel, required: true };

    //const payPeriods = paymentPeriods.map(p => (this.props.intl.formatMessage({ id: "GENERAL.FORMS." + p })));
    const payPeriods = paymentPeriods.map(p => languageFile[`GENERAL.FORMS.${p}`]);

    fields.DelayPaymentPeriod.paymentPeriods = payPeriods;

    const QuoteFields = placeholdersQA.QuoteFields;
    if (QuoteFields) {
        QuoteFields.values.forEach(fieldItem => {
            if (fields[fieldItem.field]) {
                fields[fieldItem.field].label = fieldItem.isActive ? fieldItem.display : '';
                fields[fieldItem.field].visible = fieldItem.isActive ? true : false;
            }
        });
    }

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getQuoteReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract, componentProps) => {
    const replyFields = { ...defaultReplyFields };

    replyFields.ReplyAmount = { visible: true, label: languageFile["CONTRACT.WF.QUOTES.FIELD.AMOUNT"], required: true };
    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };

    const replyOptionsPRO = [1, 0, 3, 5];

    var quoteStatuses = placeholdersQA.QuoteStatuses.values.filter((item) => item.isActive === true)
        .map(x => ({ value: +x.field, display: x.display }))
        .filter(y => replyOptionsPRO.includes(y.value))
        .sort((a, b) => a.display.localeCompare(b.display));

    replyFields.ReplyStatus.quoteStatuses = quoteStatuses;

    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };

    return replyFields;
}

class QuoteRouter extends React.Component {
    constructor(props) {
        super(props);

        this.notifyingParty = props.parentWorkflowItem.quotingParty;
        this.replyingParty = props.parentWorkflowItem.quoteReplyingParty;


        this.configurableITQFields = {};

        try {
            const projectITQFields = props.placeholders.find(ph => ph.replacementKey === 'ITQFields');

            if (projectITQFields) {
                projectITQFields.values.forEach(fieldItem => {
                    this.configurableITQFields[fieldItem.field] = fieldItem.isActive ? fieldItem.display : '';
                });
            }
        } catch (error) {
            console.log('Error loading ITQ Fields Placeholder!');
        }

        this.notificationType = props.parentWorkflowItem.config.quotationType;
        this.documentType = props.parentWorkflowItem.config.quotationDocumentType;


        this.referenceType = 'ItqQuotation';


        this.notificationAbbreviation_ITQ = (this.props.workflowsQA['72'] || {}).abbreviation;

        const baseNotification = this.props.itq;
        this.notificationName = props.parentWorkflowItem.quoteNotificationName;
        this.abbreviation = props.parentWorkflowItem.quoteReferencePrefix;
        this.pageTitle = this.props.intl.formatMessage({ id: 'GENERAL.NOTICE.TITLE' }, { ITEM_NAME: this.notificationName, PARTY_NAME: props.globalResources[this.notifyingParty + "_NAME"] });

        const fields = getQuoteFields(props.resources, props.placeholdersQA, props.workflowsQA, allMessages[this.props.lang], this.props.workflowItem.id,props.globalResources,props.contract, props);
        const replyFields = getQuoteReplyFields(props.resources, props.placeholdersQA, props.workflowsQA, allMessages[this.props.lang], this.props.workflowItem.id, props.globalResources, props.contract, props);

        //this.fields = { ...defaultFields };
        // this.fields.Description = this.props.resources.DescriptionLabel;
        // this.fields.ItemsList = this.props.resources.ItemsListLabel;
        // this.fields.TotalListPrice = this.props.resources.TotalListPriceLabel;
        // this.fields.InstructionToQuoteDescription = this.props.resources.InstructionToQuoteDescription;
        // this.fields.TotalAssessed = this.props.resources.TotalAssessedLabel;
        // this.fields.TotalPrice = this.props.resources.TotalPriceLabel;
        // this.fields.StartDate = this.props.resources.StartDateLabel;
        // this.fields.CompletionDate = this.props.resources.CompletionDateLabel;
        // this.fields.DelayAmount = this.props.resources.DelayAmountLabel;
        // this.fields.DelayPaymentPeriod = this.props.resources.DelayPaymentPeriodLabel;
        // this.fields.Comments = this.props.resources.Comments;

        //Create a Custom WorkflowItem for Quote as its not a WF standalone
        this.workflowItem = {
            ...props.parentWorkflowItem,
            fields: fields,
            replyFields: replyFields,
            pageTitle: this.pageTitle,
            notificationName: this.notificationName,
            abbreviation: this.abbreviation,
            replyEnabled: true,
            notifyingParty: props.parentWorkflowItem.quotingParty,
            replyingParty: props.parentWorkflowItem.quoteReplyingParty,
            notifyAttachments: props.parentWorkflowItem.notifyAttachments,
            replyAttachments: props.parentWorkflowItem.notifyAttachments,
            includePdfjson: props.parentWorkflowItem.includePdfjson,
            userFilters: {
                ...props.parentWorkflowItem.userFilters,
                mainNotice: {
                    createFilter: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteFilter,
                    createAllowed: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteAllowed,
                    viewDraftFilter: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteFilter,
                    viewDraftAllowed: props.parentWorkflowItem.userFilters.quoteMainNotice.createQuoteAllowed,
                    communicateFilter: props.parentWorkflowItem.userFilters.quoteMainNotice.communicateQuoteFilter,
                    communicateAllowed: props.parentWorkflowItem.userFilters.quoteMainNotice.communicateQuoteAllowed
                },
                replyNotice: {
                    saveDraftReplyFilter: props.parentWorkflowItem.userFilters.quoteReplyNotice.saveQuoteDraftReplyFilter,
                    saveDraftReplyAllowed: props.parentWorkflowItem.userFilters.quoteReplyNotice.saveQuoteDraftReplyAllowed,
                    communicateReplyFilter: props.parentWorkflowItem.userFilters.quoteReplyNotice.communicateQuoteReplyFilter,
                    communicateReplyAllowed: props.parentWorkflowItem.userFilters.quoteReplyNotice.communicateQuoteReplyAllowed
                }
            },
            paths: {
                ...props.parentWorkflowItem.paths,
                basePath: props.parentWorkflowItem.paths.basePath + baseNotification.instructiontoquoteid + "/itqquote/",
                createPath: props.parentWorkflowItem.paths.basePath + baseNotification.instructiontoquoteid + "/itqquote/create",
                listPath: props.parentWorkflowItem.paths.basePath + baseNotification.instructiontoquoteid,
                defaultPath: props.parentWorkflowItem.paths.basePath + baseNotification.instructiontoquoteid,
            },
            config: {
                ...props.parentWorkflowItem.config
            },
            associatedWFListAllowed: null
        };

        this.workflowItem.form_NotifyCompanyLogoID = Common.GetPartyOrUserCompanyID(props.contract, this.workflowItem.form_CompanyLogo, this.workflowItem.notifyingParty, props.userProfile);
        this.workflowItem.form_NotifyCompanyName = Common.GetPartyOrUserCompanyName(props.contract, this.workflowItem.form_CompanyName, this.workflowItem.notifyingParty, props.userProfile);
        this.workflowItem.form_ReplyCompanyLogoID = Common.GetPartyOrUserCompanyID(props.contract, this.workflowItem.form_CompanyLogo, this.workflowItem.replyingParty, props.userProfile);
        this.workflowItem.form_ReplyCompanyName = Common.GetPartyOrUserCompanyName(props.contract, this.workflowItem.form_CompanyName, this.workflowItem.replyingParty, props.userProfile);

        // try {
        //     const QuoteFields = props.placeholders.find(ph => ph.replacementKey === 'QuoteFields');
        //     if (QuoteFields) {
        //         QuoteFields.values.forEach(fieldItem => {
        //             this.fields[fieldItem.field] = fieldItem.isActive ? fieldItem.display : '';
        //         });
        //     }
        // } catch (error) {
        //     console.log('Error loading Quote Fields Placeholder!');
        // }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.itq !== nextProps.itq) {
            return true;
        }
        return false;
    }
    render() {
        const baseNotification = this.props.itq;
        const baseNotificationReadyForCreate = itqQuotableStatuses.includes(baseNotification.status);

        return (
            <Routes caseSensitive>
                <Route
                    path={'/itqquote/create'}
                    exact
                    element={
                        baseNotificationReadyForCreate && this.workflowItem.userFilters.quoteMainNotice.createQuoteAllowed ? (
                            <QuoteCreate
                                {...this.props}
                                mode={this.props.mode}
                                itq={baseNotification}
                                parentTabPanel={this.props.parentTabPanel}

                                title={this.notificationName}
                                abbreviation={this.abbreviation}
                                notificationType={this.notificationType}
                                workflowItem={this.workflowItem}
                                configurableITQFields={this.configurableITQFields}
                            />) : (
                            <Navigate replace to={this.workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/itqquote/:quotationid'}
                    exact
                    element={<QuoteDetail
                        {...this.props}
                        notificationAbbreviation_ITQ={this.notificationAbbreviation_ITQ}
                        mode={this.props.mode}
                        parentTabPanel={this.props.parentTabPanel}
                        onItqChanged={this.props.onItqChanged}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}

                        documentType={this.documentType}
                        baseNotificationReadyForCreate={baseNotificationReadyForCreate}
                        instructionToQuote={baseNotification}
                        notificationType={this.notificationType}
                        notifyUserFilter={this.props.notifyUserFilter}
                        workflowItem={this.workflowItem}
                    />}
                />
                <Route
                    path="*"
                    element={<QuoteList
                        {...this.props}
                        notificationAbbreviation_ITQ={this.notificationAbbreviation_ITQ}
                        mode={this.props.mode}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}

                        workflowItem={this.workflowItem}
                        notificationType={this.notificationType}
                        baseNotificationReadyForCreate={baseNotificationReadyForCreate}
                        reference={this.props.reference}
                        notifyingParty={this.notifyingParty}
                    />}
                />
            </Routes>
        );
    }
};

const mapStateToProps = store => ({
    //WE NEED userProfile because Common.GetPartyOrUserCompanyID is re-assigned depending on party
    userProfile: store.auth.userProfile,
    lang: store.i18n.lang
});

export default connect(mapStateToProps)(QuoteRouter);